import { Permission } from '@affine/graphql';

export function canCreateDocFromCachedWorkspaceRole(
  role: Permission | null | undefined
): boolean {
  return (
    role === Permission.Owner ||
    role === Permission.Admin ||
    role === Permission.Editor
  );
}
